(function() { window.GUID_afcc8639_83ff_40ac_986c_4d93aa704e2b = { getGuid: function() { return "afcc8639-83ff-40ac-986c-4d93aa704e2b"; } }; })();
var CS;
(function (CS) {
    var Views;
    (function (Views) {
        var Account;
        (function (Account) {
            class EmailSubscription extends Views.ViewBase {
                OnDispose() {
                }
                constructor() {
                    super();
                    var checkboxChanged = CS.Controls.CheckBox.Events.CheckboxValueChanged;
                    checkboxChanged({
                        selector: "#checkbox-selectall",
                        callback: (ctrl, e) => {
                            let checkboxes = $('.checkbox:not(#checkbox-selectall)');
                            checkboxes.each(function () {
                                CS.Controls.GetInstance(CS.Controls.CheckBox, $(this)).SetValue(ctrl.GetValue() == 'true');
                            });
                        }
                    });
                    checkboxChanged({
                        selector: CS.DOM.$sectionMaster,
                        childSelector: ".checkbox:not(#checkbox-selectall)",
                        callback: (ctrl, e) => {
                            let $checkboxes = $('.checkbox:not(#checkbox-selectall)');
                            let $checkboxAll = $('#checkbox-selectall');
                            let checkboxAll = CS.Controls.GetInstance(CS.Controls.CheckBox, $checkboxAll);
                            let valueOr = ctrl.GetValue() == "true";
                            let valueAnd = ctrl.GetValue() == "true";
                            $checkboxes.each(function () {
                                let currentValue = CS.Controls.GetInstance(CS.Controls.CheckBox, $(this)).GetValue() == "true";
                                valueOr = valueOr || currentValue;
                                valueAnd = valueAnd && currentValue;
                            });
                            if (valueAnd == valueOr) {
                                checkboxAll.SetValue(valueAnd);
                            }
                            else {
                                checkboxAll.SetValue(null);
                            }
                        }
                    });
                }
            }
            Views.PageContext.OnPageLoaded({ actionName: "emailsubscription", controllerName: "emailsubscriptionfromemail" }, () => new EmailSubscription());
        })(Account = Views.Account || (Views.Account = {}));
    })(Views = CS.Views || (CS.Views = {}));
})(CS || (CS = {}));

//# sourceMappingURL=account.email-subscription.js.map
